var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2041 20.4199C4.6811 20.4199 0.204102 15.9429 0.204102 10.4199C0.204102 4.89792 4.6811 0.419922 10.2041 0.419922C15.7271 0.419922 20.2041 4.89792 20.2041 10.4199C20.2041 15.9429 15.7271 20.4199 10.2041 20.4199ZM10.2041 5.41992C9.93888 5.41992 9.68453 5.52528 9.49699 5.71281C9.30946 5.90035 9.2041 6.15471 9.2041 6.41992V11.4199C9.2041 11.6851 9.30946 11.9395 9.49699 12.127C9.68453 12.3146 9.93888 12.4199 10.2041 12.4199C10.4693 12.4199 10.7237 12.3146 10.9112 12.127C11.0987 11.9395 11.2041 11.6851 11.2041 11.4199V6.41992C11.2041 6.15471 11.0987 5.90035 10.9112 5.71281C10.7237 5.52528 10.4693 5.41992 10.2041 5.41992ZM10.2041 15.4199C10.4693 15.4199 10.7237 15.3146 10.9112 15.127C11.0987 14.9395 11.2041 14.6851 11.2041 14.4199C11.2041 14.1547 11.0987 13.9004 10.9112 13.7128C10.7237 13.5253 10.4693 13.4199 10.2041 13.4199C9.93888 13.4199 9.68453 13.5253 9.49699 13.7128C9.30946 13.9004 9.2041 14.1547 9.2041 14.4199C9.2041 14.6851 9.30946 14.9395 9.49699 15.127C9.68453 15.3146 9.93888 15.4199 10.2041 15.4199Z",
    fill: "#D93A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.db34ad067ceffbe1524b7ccd4a6f2ddf.svg";
export { ForwardRef as ReactComponent };